import React from 'react';
import { Space, Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils/lib/hooks';
import modules_0e839d3f from './Navigation.module.less.js';

const { Link } = Typography;
const makeBottomNav = (item) => item.children?.map((elem) => elem.noindex ? (React.createElement(Link, { href: elem.href, color: "gray", ...(elem.nofollow ? { rel: 'nofollow' } : {}), key: elem.href },
    React.createElement("noindex", null, elem.text))) : (React.createElement(Link, { href: elem.href, color: "gray", ...(elem.nofollow ? { rel: 'nofollow' } : {}), key: elem.href }, elem.text)));
/**
 * @description Navigation.
 *
 * @component
 * @example
 * ```jsx
 * <Navigation />
 * ```
 */
const Navigation = React.forwardRef((props, ref) => {
    const { menuLinks, className, ...restProps } = props;
    const cx = useStyles(modules_0e839d3f);
    return (React.createElement(Space, { ref: ref, size: [16, 12], className: cx(className, 'navigation'), wrap: true, ...restProps }, menuLinks.map(makeBottomNav)));
});
Navigation.displayName = 'Navigation';

export { Navigation };
//# sourceMappingURL=Navigation.js.map
